import { render, staticRenderFns } from "./AgentTypingBubble.vue?vue&type=template&id=35012b80&scoped=true&"
import script from "./AgentTypingBubble.vue?vue&type=script&lang=js&"
export * from "./AgentTypingBubble.vue?vue&type=script&lang=js&"
import style0 from "./AgentTypingBubble.vue?vue&type=style&index=0&id=35012b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35012b80",
  null
  
)

export default component.exports